/*
 * user (schema)
 */
import { timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"

export const users = schema.table("users", {
	// Primary key - matches auth.users.id (1:1 relationship)
	id: uuid("id").primaryKey().notNull(),

	preferredName: varchar("preferred_name", { length: 32 }).notNull(),
	avatarUrl: varchar("avatar_url", { length: 256 }),
	timezone: varchar("timezone", { length: 64 }),

	// --- System ---
	createdAt: timestamp("created_at", { withTimezone: true })
		.defaultNow()
		.notNull(),
	updatedAt: timestamp("updated_at", { withTimezone: true })
		.defaultNow()
		.notNull(),
})
